const ctx = require.context('@/assets/img/avatar/', false, /\.(png|jpe?g|webp)$/)

const avatarSrcMap = ctx.keys().reduce((m, path) => {
  const file = path.replace('./', '')                   // 'seungwook.han.png'
  const key  = file.replace(/\.(png|jpe?g|webp)$/i, '') // 'seungwook.han'
  m[key] = ctx(path)                                    // 번들된 url
  return m
}, {})

// 이메일/로컬파트 → 아바타 URL
export function getAvatarById(emailOrLocal) {
  const local = String(emailOrLocal || '')
  const lp = local.includes('@') ? local.split('@')[0] : local
  return avatarSrcMap[lp] || avatarSrcMap['default'] // default.png 준비!
}

export { avatarSrcMap }